module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', {
    staticClass: "ql-structure-header",
    class: 'ql-structure-header--' + _vm.resolvedType,
    attrs: {
      "data-ql-structure": _vm.markerKey
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "100"
    }
  }, [_c('div', {
    staticClass: "ql-structure-header-inner",
    style: (_vm.barStyle),
    attrs: {
      "title": _vm.jumpTooltip
    },
    on: {
      "click": _vm.switchViewToPage
    }
  }, [(_vm.resolvedType === 'song') ? _c('span', {
    staticClass: "ql-structure-header-glyph",
    attrs: {
      "aria-label": "Song"
    }
  }, [_vm._v("♪")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "ql-structure-header-label"
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('span', {
    staticClass: "ql-structure-header-meta"
  }, [(_vm.empty) ? _c('span', {
    staticClass: "ql-structure-header-nocues"
  }, [_vm._v("no cues")]) : _vm._e(), _vm._v("p " + _vm._s(_vm.pageName) + "\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11a03e7c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/list-view/structure-header-row.vue
// module id = 1203
// module chunks = 21